import { createFileRoute } from '@tanstack/react-router';

import { CookiesPage } from '../features/consent/cookies-page.js';

export const Route = createFileRoute('/cookies')({
  component: CookiesPage,
});
